import { z } from "zod";
import { schemes } from "../../schema-validation";
import { common } from "./common";

export const accrualSchema = z.object({
  employeeID: schemes.mongoObjectId(),
  effective_date: schemes.isoDate(),
  amount: z.number(),
});

export const accrual = z
  .object({
    employees: z.array(accrualSchema),
  })
  .merge(common);

export type AccrualUpdate = {
  updateOne: {
    filter: {
      companyID: string;
      policyID: string;
      employeeID: string;
    };
    update: {
      $set: {
        balance: number;
        accrued?: number;
      };
    };
  };
}[];
export type Accrual = z.infer<typeof accrual>;
export type EmployeeAccrual = z.infer<typeof accrualSchema>;
